export function PaginationBreakDots({ dataTestId }: { dataTestId?: string }) {
  return (
    <span className="mx-1 text-gray-500" data-testid={dataTestId}>
      &#8230;
    </span>
  );
}
